import injured from './injured';
import suspended from './suspended';
import Reported from './reported';
import uncertain from './uncertain';
import close from './close';
import missing from './missing';

export {injured, suspended, Reported, uncertain, close, missing};



// WEBPACK FOOTER //
// ./src/components/Icon/svg/index.js